import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Clock, ArrowRight, ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`).then(res => setPosts(res.data)).catch(console.error);
  }, []);

  return (
    <div>
      <div className="bg-[#EFEBE5] px-6 md:px-12 lg:px-24 py-3">
        <div className="max-w-7xl mx-auto flex items-center gap-2 text-sm font-body text-[#6B6B6B]">
          <Link to="/" className="hover:text-[#2D5016]">Accueil</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-[#2D5016] font-medium">Blog</span>
        </div>
      </div>

      <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-[#C8A951] font-body text-sm tracking-[0.3em] uppercase mb-3">Recits & inspirations</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#2C2C2C]">Le blog VisitMonde</h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post, i) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className={`group bg-white rounded-xl overflow-hidden shadow-[0_4px_20px_-2px_rgba(45,80,22,0.06)] hover:shadow-[0_8px_30px_-4px_rgba(45,80,22,0.12)] transition-all ${i === 0 ? 'md:col-span-2 lg:col-span-2' : ''}`}
                data-testid={`blog-card-${post.slug}`}
              >
                <div className={`overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                  <img src={post.hero_image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3 text-xs font-body text-[#6B6B6B]">
                    <span>{post.published_date}</span>
                    <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {post.read_time} min</span>
                  </div>
                  <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-2 group-hover:text-[#2D5016] transition-colors">{post.title}</h2>
                  <p className="font-body text-sm text-[#6B6B6B] leading-relaxed mb-4">{post.excerpt}</p>
                  <span className="font-body text-sm text-[#2D5016] font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    Lire l'article <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
